var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.881,
    height: 12.716,
    viewBox: "0 0 10.881 12.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "TikTok",
    d: "M7.755,0H5.933L5.914,8.882A2.02,2.02,0,0,1,3.863,10.83a1.972,1.972,0,1,1,0-3.943A1.982,1.982,0,0,1,4.1,6.91v-1.9c-.079,0-.158-.012-.239-.012A3.863,3.863,0,1,0,7.727,8.857V3.63a3.394,3.394,0,0,0,2.84,1.535q.157,0,.313-.016h0V3.034A3.393,3.393,0,0,1,7.755,0",
    transform: "translate(0 -0.005)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.229f3c59426d876ffc3b4606f628d973.svg";
export { ForwardRef as ReactComponent };